import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { EDisplayFormat } from '../_common/enum.js';
import { validateField } from '../index.js';

export const EditCampaignSchema = T.Object({
  uuid: T.String({ format: 'uuid', error: 'Uuid da campanha é um campo obrigatório' }),
  name: T.String({ minLength: 1, error: 'Nome da campanha é um campo obrigatório' }),
  displayFormat: T.Enum(EDisplayFormat, { error: 'Formato de exibição é um campo obrigatório' }),
  startDate: T.String({ error: 'Data de início é um campo obrigatório' }),
  endDate: T.Optional(T.String()),
  description: T.Optional(T.String()),
  medias: T.Array(T.String({ format: 'uuid', error: 'Medias deve ser um array de uuid' })),
  brand: T.String({ format: 'uuid', error: 'A marca é um campo obrigatório do tipo uuid' }),
  segmentation: T.Array(
    T.Object({
      uuid: T.String({ format: 'uuid', error: 'UUID é um campo obrigatório do tipo uuid' }),
      name: T.String({ error: 'Nome é um campo obrigatório' }),
      isState: T.Boolean({ error: 'isState é um campo obrigatório' }),
    })
  ),
  thumbnailFileType: T.Optional(T.Union([T.String({ error: 'Thumbnail é obrigatória' }), T.Literal('REMOVE')])),
  /** Pre-uploaded thumbnail key from image.uploadCompressed endpoint */
  thumbnailKey: T.Optional(T.String()),
});

export type EditCampaignInputType = typeof EditCampaignSchema.static;

export async function ValidateEditCampaignInput(value: unknown): Promise<EditCampaignInputType> {
  return Value.Parse(EditCampaignSchema, value);
}

export function checkCampaignEditInput(field: string, value: unknown): string | boolean {
  return validateField(EditCampaignSchema, field, value);
}
